import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { isAndroid, isInstalledApp, isIOS } from 'app/main/utils/installedApp';
import useInstallPrompt from 'app/main/utils/useInstallPrompt';

function InstallInstructions({ onClose }) {
  return (
    <>
      <DialogTitle>Install iCentral</DialogTitle>
      <DialogContent>
        <Typography>
          {isIOS() ? (
            <>
              In Safari, tap <strong>Share</strong>, then <strong>Add to Home Screen</strong>.
            </>
          ) : (
            <>
              Open the browser menu (<strong>⋮</strong>) and tap <strong>Install app</strong> or{' '}
              <strong>Add to Home screen</strong>. If iCentral is already installed, open it from your home screen.
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Got it
        </Button>
      </DialogActions>
    </>
  );
}

function InstallAppButton() {
  const dispatch = useDispatch();
  const { installPrompt, install } = useInstallPrompt();

  // Desktop browsers without the prompt either cannot install or already have it installed.
  if (isInstalledApp() || (!installPrompt && !isIOS() && !isAndroid())) return null;

  const handleClick = () => {
    if (installPrompt) {
      install();
      return;
    }
    dispatch(openDialog({ children: <InstallInstructions onClose={() => dispatch(closeDialog())} /> }));
  };

  return (
    <Tooltip title="Install app">
      <IconButton className="p-0 text-black" aria-label="Install app" onClick={handleClick}>
        <Icon className="text-20 lg:text-24">get_app</Icon>
      </IconButton>
    </Tooltip>
  );
}

export default InstallAppButton;
